import React, { useState, useContext } from 'react';
import Regex from '../../utils/regex';
import { Input, Select, message, Icon } from 'antd';
import TitleBanner from '../../components/TitleBanner';
import PhoneNumberValidation from '../../components/PhoneNumberValidation/PhoneNumberValidation';
import { InputLabel, InputContainer } from '../../components/Modals/styles';
import { SubmitButton } from './styles';
import { AppStoreContext } from '../../context/appStoreContext.js';
import { CreateOrganisation } from '../../utils/services/onPremAPI';
import { withTranslation } from 'react-i18next';
import { ORGANIZATION_SETUP } from './translationValues';

const NAMESPACES = ['ORGANIZATION_SETUP'];

const OrganizationSetupPage = props => {
  const { setShowSignIn, t } = props;
  const { countryList } = useContext(AppStoreContext);

  const { Option } = Select;

  const [loading, setLoading] = useState(false);
  const [organisationDetail, setOrganisationDetail] = useState({
    name: '',
    phoneNumber: '',
    addressLine1: '',
    addressLine2: '',
    contactFirstName: '',
    contactLastName: '',
    contactEmail: '',
    licenseKey: '',
    zip: '',
    State: '',
    Country: 'United States',
    city: '',
  });
  const [emailError, setEmailError] = useState(false);
  const [mobileError, setMobileError] = useState(false);

  const handleInputChange = e => {
    let { name, value } = e.target;
    if (name === 'contactEmail') {
      const isValidEmail = Regex.EMAIL.test(value);
      setEmailError(!isValidEmail);
    }

    setOrganisationDetail({
      ...organisationDetail,
      [name]: value,
    });
  };

  const handleActivationKeyChange = e => {
    setOrganisationDetail({ ...organisationDetail, licenseKey: e.target.value });
  };

  const isDataValid = () => {
    const orgInfo = Object.keys(organisationDetail);
    for (const key of orgInfo) {
      if (key !== 'addressLine2' && organisationDetail[key] === '') {
        return false;
      }
    }
    return true;
  };

  const activateOrganisation = async () => {
    setLoading(true);
    const payload = { ...organisationDetail };
    const response = await CreateOrganisation(payload);
    setLoading(false);
    if (response.statusCode === 1900) {
      message.success(
        t(
          ORGANIZATION_SETUP.ORGANIZATION_CREATED_SUCCESS_MESSAGE.key,
          ORGANIZATION_SETUP.ORGANIZATION_CREATED_SUCCESS_MESSAGE.value,
        ),
      );
      setShowSignIn(true);
    } else {
      if (response.errors && response.errors.length > 0) {
        // message.error(response.errors[0].description);
      } else {
        message.error(
          t(
            ORGANIZATION_SETUP.ORGANIZATION_CREATION_ERROR_MESSAGE.key,
            ORGANIZATION_SETUP.ORGANIZATION_CREATION_ERROR_MESSAGE.value,
          ),
        );
      }
    }
  };

  const isFormValid = isDataValid() && !emailError && !mobileError;

  const uniqueCountryList = countryList.filter((obj, index) => {
    return index === countryList.findIndex(o => obj.name === o.name);
  });

  return (
    <div className="organisation-form">
      <TitleBanner
        title={t(
          ORGANIZATION_SETUP.SETUP_ORGANIZATION_TITLE.key,
          ORGANIZATION_SETUP.SETUP_ORGANIZATION_TITLE.value,
        )}
      />
      <div className="form-container">
        <InputContainer bottom-0 signUp efax>
          <InputLabel>
            {t(
              ORGANIZATION_SETUP.ORGANIZATION_NAME_LABEL.key,
              ORGANIZATION_SETUP.ORGANIZATION_NAME_LABEL.value,
            )}{' '}
            <span className="asterisk">*</span>
          </InputLabel>
          <Input
            autoFocus={true}
            size="large"
            value={organisationDetail.name}
            onChange={handleInputChange}
            maxLength={50}
            name="name"
          />
        </InputContainer>

        <InputContainer bottom-0 signUp>
          <InputLabel>
            {t(
              ORGANIZATION_SETUP.PHONE_NUMBER_LABEL.key,
              ORGANIZATION_SETUP.PHONE_NUMBER_LABEL.value,
            )}{' '}
            <span className="asterisk">*</span>
          </InputLabel>
          <PhoneNumberValidation
            setValid={setMobileError}
            onchange={value => {
              setOrganisationDetail({ ...organisationDetail, phoneNumber: value });
            }}
          />
          {mobileError && (
            <InputLabel error signUp>
              {t(
                ORGANIZATION_SETUP.PHONE_NUMBER_INVALID_ERROR_MESSAGE.key,
                ORGANIZATION_SETUP.PHONE_NUMBER_INVALID_ERROR_MESSAGE.value,
              )}
            </InputLabel>
          )}
        </InputContainer>

        <div className="names">
          <InputContainer bottom-0 signUp>
            <InputLabel>
              {t(
                ORGANIZATION_SETUP.CONTACT_PERSON_FIRST_NAME_LABEL.key,
                ORGANIZATION_SETUP.CONTACT_PERSON_FIRST_NAME_LABEL.value,
              )}{' '}
              <span className="asterisk">*</span>
            </InputLabel>
            <Input
              size="large"
              value={organisationDetail.contactFirstName}
              onChange={handleInputChange}
              maxLength={20}
              name="contactFirstName"
            />
          </InputContainer>

          <InputContainer bottom-0 signUp>
            <InputLabel>
              {t(
                ORGANIZATION_SETUP.CONTACT_PERSON_LAST_NAME_LABEL.key,
                ORGANIZATION_SETUP.CONTACT_PERSON_LAST_NAME_LABEL.value,
              )}{' '}
              <span className="asterisk">*</span>
            </InputLabel>
            <Input
              size="large"
              value={organisationDetail.contactLastName}
              onChange={handleInputChange}
              maxLength={20}
              name="contactLastName"
            />
          </InputContainer>
        </div>
        <InputContainer bottom-0 signUp>
          <InputLabel>
            {t(
              ORGANIZATION_SETUP.CONTACT_PERSON_EMAIL_LABEL.key,
              ORGANIZATION_SETUP.CONTACT_PERSON_EMAIL_LABEL.value,
            )}{' '}
            <span className="asterisk">*</span>
          </InputLabel>
          <Input
            size="large"
            value={organisationDetail.contactEmail}
            onChange={handleInputChange}
            maxLength={50}
            name="contactEmail"
          />
          {emailError && (
            <InputLabel error signUp>
              {t(
                ORGANIZATION_SETUP.EMAIL_INVALID_ERROR_MESSAGE.key,
                ORGANIZATION_SETUP.EMAIL_INVALID_ERROR_MESSAGE.value,
              )}
            </InputLabel>
          )}
        </InputContainer>

        <InputContainer bottom-0 signUp efax>
          <InputLabel>
            {t(ORGANIZATION_SETUP.COUNTRY_LABEL.key, ORGANIZATION_SETUP.COUNTRY_LABEL.value)}{' '}
            <span className="asterisk">*</span>
          </InputLabel>
          <Select
            style={{ width: 200 }}
            onChange={value => {
              setOrganisationDetail({ ...organisationDetail, Country: value });
            }}
            optionFilterProp="children"
            showSearch
            value={organisationDetail.Country}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {uniqueCountryList.map((list, index) => {
              return (
                <Option value={list.name} key={index}>
                  {list.name}
                </Option>
              );
            })}
          </Select>
        </InputContainer>

        <InputContainer bottom-0 signUp>
          <InputLabel>
            {t(ORGANIZATION_SETUP.STATE_LABEL.key, ORGANIZATION_SETUP.STATE_LABEL.value)}{' '}
            <span className="asterisk">*</span>
          </InputLabel>
          <Input
            size="large"
            value={organisationDetail.State}
            onChange={handleInputChange}
            maxLength={20}
            name="State"
          />
        </InputContainer>

        <div className="names">
          <InputContainer bottom-0 signUp>
            <InputLabel>
              {t(ORGANIZATION_SETUP.CITY_LABEL.key, ORGANIZATION_SETUP.CITY_LABEL.value)}{' '}
              <span className="asterisk">*</span>
            </InputLabel>
            <Input
              size="large"
              value={organisationDetail.city}
              onChange={handleInputChange}
              maxLength={20}
              name="city"
            />
          </InputContainer>

          <InputContainer bottom-0 signUp>
            <InputLabel>
              {t(ORGANIZATION_SETUP.ZIP_CODE_LABEL.key, ORGANIZATION_SETUP.ZIP_CODE_LABEL.value)}{' '}
              <span className="asterisk">*</span>
            </InputLabel>
            <Input
              size="large"
              value={organisationDetail.zip}
              onChange={handleInputChange}
              maxLength={10}
              name="zip"
            />
          </InputContainer>
        </div>

        <InputContainer bottom-0 signUp>
          <InputLabel>
            {t(
              ORGANIZATION_SETUP.ADDRESS_LINE_LABEL.key,
              ORGANIZATION_SETUP.ADDRESS_LINE_LABEL.value,
            )}{' '}
            1 <span className="asterisk">*</span>
          </InputLabel>
          <Input
            size="large"
            value={organisationDetail.addressLine1}
            onChange={handleInputChange}
            maxLength={100}
            name="addressLine1"
          />
        </InputContainer>

        <InputContainer bottom-0 signUp>
          <InputLabel>
            {t(
              ORGANIZATION_SETUP.ADDRESS_LINE_LABEL.key,
              ORGANIZATION_SETUP.ADDRESS_LINE_LABEL.value,
            )}{' '}
            2
          </InputLabel>
          <Input
            size="large"
            value={organisationDetail.addressLine2}
            onChange={handleInputChange}
            maxLength={100}
            name="addressLine2"
          />
        </InputContainer>

        <InputContainer bottom-0 signUp>
          <InputLabel>
            {t(
              ORGANIZATION_SETUP.ACTIVATION_KEY_LABEL.key,
              ORGANIZATION_SETUP.ACTIVATION_KEY_LABEL.value,
            )}{' '}
            <span className="asterisk">*</span>
          </InputLabel>
          <Input
            size="large"
            value={organisationDetail.licenseKey}
            onChange={handleActivationKeyChange}
            maxLength={41}
            name="licenseKey"
          />
        </InputContainer>

        <SubmitButton
          org
          onClick={() =>
            isFormValid
              ? activateOrganisation()
              : message.error(
                  t(
                    ORGANIZATION_SETUP.ALL_FIELDS_REQUIRED_ERROR_MESSAGE.key,
                    ORGANIZATION_SETUP.ALL_FIELDS_REQUIRED_ERROR_MESSAGE.value,
                  ),
                )
          }
          disable={!isFormValid}
        >
          <div className="wrap-1">
            <div>
              {loading
                ? t(
                    ORGANIZATION_SETUP.ACTIVATING_ORGANIZATION_BUTTON.key,
                    ORGANIZATION_SETUP.ACTIVATING_ORGANIZATION_BUTTON.value,
                  )
                : t(
                    ORGANIZATION_SETUP.ACTIVATE_ORGANIZATION_BUTTON.key,
                    ORGANIZATION_SETUP.ACTIVATE_ORGANIZATION_BUTTON.value,
                  )}
            </div>
            {loading ? <Icon type="loading" className="loading" /> : <div className="arrow"></div>}
          </div>
          <div className="wrap-2">
            <div>
              {loading
                ? t(
                    ORGANIZATION_SETUP.ACTIVATING_ORGANIZATION_BUTTON.key,
                    ORGANIZATION_SETUP.ACTIVATING_ORGANIZATION_BUTTON.value,
                  )
                : t(
                    ORGANIZATION_SETUP.ACTIVATE_ORGANIZATION_BUTTON.key,
                    ORGANIZATION_SETUP.ACTIVATE_ORGANIZATION_BUTTON.value,
                  )}
            </div>
            {loading ? <Icon type="loading" className="loading" /> : <div className="arrow"></div>}
          </div>
        </SubmitButton>
      </div>
    </div>
  );
};

export default withTranslation(NAMESPACES)(OrganizationSetupPage);
